import React from "react";
import { Building2, Briefcase, GraduationCap, Target, ShieldCheck } from "lucide-react";
import { C } from "./shared";

/* TrustedByStrip — the four-stakeholder trust wall. Phase C upgrade:
 * bigger, badged, with a sub-band of trust signals (governance / verified /
 * Tech Catalyst). Sits just above the footer. */

const ENTRIES = [
  [Building2,     "Institutions",          C.navy],
  [Briefcase,     "Companies",             C.orange],
  [GraduationCap, "Students",              C.green],
  [Target,        "Working Professionals", C.purple || "#6D28D9"],
];

const TRUST = [
  "MeitY-aligned governance",
  "Verified certificates",
  "Enterprise-grade security",
  "ISO 27001 patterns",
];

export default function TrustedByStrip() {
  return (
    <section className="bg-white border-t" style={{ borderColor: C.rule }}>
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="text-center mb-8">
          <span className="font-mono text-[11px] tracking-[0.18em] uppercase font-bold text-muted">
            Trusted by the four pillars of employability
          </span>
          <h3 className="font-display h-display text-2xl sm:text-3xl mt-2 text-ink">
            One platform. Every stakeholder.
          </h3>
        </div>

        {/* Big stakeholder badges */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {ENTRIES.map(([Icon, label, color], i) => (
            <div
              key={label}
              className="relative rounded-2xl border bg-white p-5 transition-all duration-500 hover:-translate-y-1 hover:shadow-lg group overflow-hidden"
              style={{ borderColor: C.rule }}
              data-testid={`trusted-${i}`}
            >
              {/* corner blob */}
              <span aria-hidden="true"
                className="pointer-events-none absolute -top-8 -right-8 w-24 h-24 rounded-full blur-2xl opacity-0 group-hover:opacity-50 transition-opacity duration-500"
                style={{ background: `radial-gradient(circle, ${color} 0%, transparent 70%)` }}
              />
              <div className="relative flex items-center gap-3">
                <div
                  className="w-12 h-12 rounded-xl grid place-items-center transition-transform duration-500 group-hover:scale-110 group-hover:rotate-[-6deg]"
                  style={{ background: `${color}15`, color }}
                >
                  <Icon size={22} strokeWidth={2.2} />
                </div>
                <div className="font-display font-extrabold text-base sm:text-lg leading-tight" style={{ color: C.ink }}>
                  {label}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust-signal sub-band */}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs text-muted">
          {TRUST.map((t) => (
            <span key={t} className="inline-flex items-center gap-1.5">
              <ShieldCheck size={13} className="text-signal" /> {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
